import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function Dienstleister(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für Dienstleister"
      title="Buchhaltung für Dienstleister – Projekte professionell abrechnen"
      subtitle="Zeit ist Geld – besonders für Dienstleister. Saldify hilft Ihnen, Ihre Projekte effizient abzurechnen und den Überblick zu behalten."
      heroImage="/screenshots/app-rechnungen.webp"
      heroImageAlt="Rechnungen und Angebote in Saldify verwalten"
      introTitle="Projektbasiert arbeiten und abrechnen"
      introText="Als Dienstleister arbeiten Sie projektbasiert. Saldify unterstützt Sie dabei, Zeiten zu erfassen, Projekte zu verwalten und professionelle Rechnungen zu erstellen."
      introBullets={[
        'Zeiterfassung pro Projekt und Kunde',
        'Stundensätze und Pauschalen flexibel kombinieren',
        'Automatische Rechnungserstellung aus erfassten Zeiten',
        'Projektrentabilität im Blick',
      ]}
      benefits={[
        {
          title: 'Zeiterfassung',
          description: 'Erfassen Sie Arbeitszeiten per App, Browser oder direkt aus Ihrem Kalender.',
        },
        {
          title: 'Projektmanagement',
          description: 'Verwalten Sie Budgets, Meilensteine und Deadlines in Saldify.',
        },
        {
          title: 'Flexible Abrechnung',
          description: 'Stundensätze, Tagessätze, Pauschalen – rechnen Sie ab, wie es passt.',
        },
        {
          title: 'Angebote erstellen',
          description: 'Professionelle Angebote mit Kostenvoranschlag und Leistungsbeschreibung.',
        },
        {
          title: 'Kundenverwaltung',
          description: 'Alle Kundendaten, Projekte und Historie an einem Ort.',
        },
        {
          title: 'Reisekosten',
          description: 'Erfassen und verrechnen Sie Reisekosten direkt mit dem Projekt.',
        },
      ]}
      useCases={[
        {
          title: 'IT-Dienstleister',
          description: 'Projektstunden erfassen, Support-Tickets abrechnen und Wartungsverträge verwalten.',
        },
        {
          title: 'Agenturen',
          description: 'Kreativprojekte managen, Teamzeiten erfassen und Kunden transparent abrechnen.',
        },
        {
          title: 'Berater',
          description: 'Beratungsstunden erfassen, Workshops abrechnen und Spesen verwalten.',
        },
        {
          title: 'Architekten & Ingenieure',
          description: 'Leistungsphasen abrechnen, Honorare nach HOAI berechnen.',
        },
      ]}
      features={[
        'Integrierte Zeiterfassung',
        'Projektbasierte Abrechnung',
        'Stundensatz-Verwaltung',
        'Angebote und Auftragsbestätigungen',
        'Reisekostenabrechnung',
        'Projektrentabilitäts-Analyse',
        'Wiederkehrende Leistungen',
        'Kunden-Portal für Freigaben',
      ]}
      recommendedPlan={{
        name: 'Professional',
        price: '24€/Monat',
        description: 'Perfekt für Dienstleister: Unbegrenzte Projekte, Zeiterfassung und erweiterte Auswertungen.',
      }}
      testimonial={{
        quote: 'Die automatische Rechnungserstellung aus meinen erfassten Zeiten spart mir jeden Monat Stunden. Einfach genial!',
        author: 'Julia S.',
        role: 'IT-Beraterin',
        company: 'Selbstständig',
      }}
    />
  );
}
